import { IconButton, } from '@mui/material';
import { Download } from "@mui/icons-material";

const styles = {
    container: {
        margin: '20px',
    },
    tabsHeader: {
        display: 'flex',
        width: '100%'
    },
    activeTab: {
        backgroundColor: 'rgb(251,230,223)',
        color: 'black',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '10px 20px',
        borderRadius: 0,
        fontWeight: 'bold',
        fontSize: "12px",
    },
    inactiveTab: {
        backgroundColor: 'white',
        color: 'black',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '10px 20px',
        border: '0px',
        borderRadius: 0,
        fontWeight: 'bold',
        fontSize: "12px",
        borderRight: '1px solid #ccc',
    },
    tabContent: {
        marginTop: '20px',
    },
    fileUploadSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        padding: '10px',
        marginBottom: '20px',
    },
    fileInput: {
        display: 'none',
        padding: '6px 12px',
    },
    uploadBtn: {
        backgroundColor: '#1976d2',
        color: 'white',
        width: '250px',
    },
    sampleFileLink: {
        marginLeft: '60px',
        textDecoration: 'none',
        color: '#1976d2',
        marginTop: '5px',
        fontSize: '13px',
        fontWeight: 'bold',

    },
    table: {
        minWidth: '650px',
    },
    th: {
        fontWeight: 'bold',
        backgroundColor: '#f0f0f0',
    },
    td: {
        padding: '10px',
    },
    button: {
        height: '40px',
        marginBottom: '10px',
        backgroundColor: 'rgb(99,88,237)',
    },
    quantityContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: 'center',
        gap: 30,
        marginTop: 60,
        marginBottom: 40
    },
    perviousDownloadsContainer: {
        width: "100%",
        height: 30,
        justifyContent: "center",
        alignItems: 'center',
        backgroundColor: 'rgb(243,245,247)',
        borderTopWidth: 1,
        borderBottomWidth: 1,
        padding: 5,
        paddingLeft: 20
    },
    uploadFileBox: {
        // width: "75%",
        display: "flex",
        // justifyContent: "center",
        alignItems: 'center',
        gap: 30,
        marginTop: 60,
        // marginBottom: 40,
        paddingLeft: 30
    },
    uploadFile: {
        // height: '33px',
        backgroundColor: 'rgb(99,88,237)',

    },
    logIdCell: {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
    },
    fileNameCell: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
    },
    statusCell: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    countCell: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    createDateCell: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    fileCell: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },


    locContainer: {
        width: "100%",
        display: "flex",
        // justifyContent: "center",
        alignItems: 'center',
        gap: 30,
        marginTop: 60,
        marginBottom: 10,
        paddingLeft: 70,
        // backgroundColor: 'red',
    },
    searchIConStyle: {
        position: "absolute",
        top: "50%",
        left: 10,
        transform: "translateY(-50%)",
        color: "gray",
        zIndex: 1,
    },
    searchIConStyle: {
        position: "absolute",
        top: "50%",
        left: 10,
        transform: "translateY(-50%)",
        color: "gray",
        zIndex: 1,
    },
    buttonBox: {
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "16px",
        marginLeft: "1rem",
        paddingLeft: 24,
        marginBottom: 2
    },
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    cardStyle: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
    },
    searchIconStyle: {
        position: "absolute",
        top: "50%",
        left: 10,
        transform: "translateY(-50%)",
        color: "gray",
        zIndex: 1,
    },
    loaderOverlay: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10
    },
};

export default styles;
export const boxSX = {
    textDecoration: "none",
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
        color: "darkblue",
    },
};

export const MigratedAssetsQrcolumns = (handleDownloadFile) => [
    {
        field: "log_id",
        headerName: "Log ID",
        flex: 1,
        headerAlign: 'center',
        align: 'center'
    },
    {
        field: "loc",
        headerName: "Location Code",
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (params.value),
    },
    {
        field: "loc_name",
        headerName: "Location Name",
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (params.value),
    },
    {
        field: "tag_count",
        headerName: "Count",
        flex: 1,
        headerAlign: 'center',
        align: 'center'
    },
    {
        field: "create_date",
        headerName: "Create Date",
        flex: 1,
        headerAlign: 'center',
        align: 'center'
    },

    {
        field: "tag_file_path",
        headerName: "File",
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <IconButton
                aria-label="Download"
                onClick={() => handleDownloadFile(params.row.tag_file_path)}
            >
                <Download color="primary" />
            </IconButton>
        ),
    },

];
